import { isMockAuthEnabled } from '@/config/authMode';

/**
 * Where the Cognito refresh token lives (`VITE_AUTH_SESSION`):
 *
 * - `local` (default, unset): Amplify's localStorage, today's behaviour.
 * - `cookie`: an HttpOnly cookie on the identity service
 *   (`<VITE_IDENTITY_API_URL>session`); access/ID tokens in memory only and no
 *   `localStorage.access_token` copy. Needs `VITE_IDENTITY_API_URL`, the page
 *   origin in the identity service's SESSION_ALLOWED_ORIGINS and a page that is
 *   SAME-SITE with the identity host (deployed: *.partnership-net.com).
 *
 * Mock auth (local only) always uses `local`.
 */
export type AuthSessionMode = 'local' | 'cookie';

const raw = String(import.meta.env.VITE_AUTH_SESSION ?? '')
  .trim()
  .toLowerCase();

/** Identity service base (`VITE_IDENTITY_API_URL`); unset = login calls stay on the gateway. */
export const identityApiUrl: string = String(import.meta.env.VITE_IDENTITY_API_URL ?? '').trim();

export const authSessionMode: AuthSessionMode =
  raw === 'cookie' && !isMockAuthEnabled && identityApiUrl !== '' ? 'cookie' : 'local';

export const isCookieSessionMode = authSessionMode === 'cookie';

/** This app's client key at the identity service's token handler. */
export const SESSION_CLIENT_KEY = 'pnet-web';

if (raw === 'cookie' && !isCookieSessionMode) {
  console.warn(
    '[AUTH_SESSION] VITE_AUTH_SESSION=cookie needs VITE_IDENTITY_API_URL (and Cognito auth); using "local".',
  );
}
